import { Title } from "@components";
import styles from "@styles/pages/reports/reports.module.scss";
import { Link } from "react-router-dom";

export default function MarketingReports() {
  const pages = [
    {
      name: "Relatórios de Campanhas",
      icon: <i className="fal fa-split" />,
      path: "campanhas",
      enabled: true,
    },
    {
      name: "Cupons",
      icon: <i className="fal fa-ticket-perforated" />,
      path: "cupons",
      enabled: true,
    },
  ];

  return (
    <>
      <Title title="Relatórios de Marketing" />

      <div className={styles.reports}>
        {pages
          .filter((p) => !!p.enabled)
          .map((page, index) => {
            return (
              <Link to={page.path} key={page.name}>
                <div className={styles.report} style={{ opacity: 1 }}>
                  <div className={styles.icon}>{page.icon}</div>
                  <p>{page.name}</p>
                </div>
              </Link>
            );
          })}
      </div>
    </>
  );
}
